import { useSWRConfig } from 'swr'

export const infiniteLists = new Set()

export default function useMatchMutate() {
    const { cache, mutate } = useSWRConfig()
    return (matcher, ...args) => {
        if (!(cache instanceof Map)) {
            throw new Error(
                'matchMutate requires the cache provider to be a Map instance',
            )
        }

        const keys = []

        for (const key of cache.keys()) {
            if (matcher.test(key)) {
                keys.push(key)
            }
        }

        const mutations = keys.map((key) => mutate(key, ...args))

        for (const entry of infiniteLists) {
            if (entry.url && matcher.test(entry.url)) {
                mutations.push(entry.mutate(...args))
            }
        }

        return Promise.all(mutations)
    }
}
